import { ADVANCED_FILTERS }                           from './advancedFilters'
import { FILTERS }                                    from '@redux/filters/filters'
import { ADVANCED_DEFAULTS, parseAdvancedFromSearch } from '@helpers/javascript/advancedSearch'

// Applied advanced filters are hydrated from the URL on load so they survive a
// reload (the app persists quick-search state through the URL).
const initialState = { ...ADVANCED_DEFAULTS, ...parseAdvancedFromSearch() }

// Touching any quick filter — including the navbar date selector (CHANGE_DATE)
// — hands the list back to the quick filters, so applied advanced filters clear.
// FILTERS.RESET is intentionally excluded: applying advanced filters dispatches
// it to restart pagination, and NEXT_PAGE must not clear the active filters.
const QUICK_FILTER_ACTIONS = [
  FILTERS.CHANGE_STATUS,
  FILTERS.CHANGE_DATE,
  FILTERS.SEARCH_WORKORDERS,
  FILTERS.SELECT_TECHNICIAN,
  FILTERS.SELECT_CATEGORY,
  FILTERS.CHANGE_FIELDS,
  FILTERS.TOGGLE_REACTIVE,
  FILTERS.TOGGLE_PREVENTIVE,
  FILTERS.TOGGLE_INSTALLATION,
  FILTERS.BY_DISTANCE
]

export default function advancedFiltersReducer(state = initialState, action) {
  if (QUICK_FILTER_ACTIONS.includes(action.type)) return { ...ADVANCED_DEFAULTS }

  switch (action.type) {
  case ADVANCED_FILTERS.APPLY:
    return { ...ADVANCED_DEFAULTS, ...action.payload.filters, applied: true }

  case ADVANCED_FILTERS.RESET:
    return { ...ADVANCED_DEFAULTS }

  default:
    return state
  }
}
